import { create } from 'zustand';

// Nur Laufzeit-Zustand (nichts im Browser gespeichert): „Später“ gilt bis
// zum nächsten Laden der App, startAngefordert kommt aus den Einstellungen.
export const useTourStore = create((set) => ({
  spaeter: false,
  aktiv: false,
  startAngefordert: false,
  setSpaeter: () => set({ spaeter: true }),
  anfordern: () => set({ startAngefordert: true }),
  startErledigt: () => set({ startAngefordert: false }),
  setAktiv: (aktiv) => set({ aktiv }),
}));
